/**
 * GA4 conversion events: demo bookings and form submissions.
 *
 * Only ever loaded by layout/theme.liquid when settings.ga4_measurement_id
 * is set, right after the gtag.js bootstrap — see the conditional block in
 * the <head>. If gtag isn't defined for any reason this file no-ops.
 *
 * No PII (emails, names, message bodies) is ever sent as an event param.
 */
(() => {
  if (typeof window.gtag !== "function") return;
  if (Shopify.designMode) return;

  const CALENDLY_ORIGIN = "https://calendly.com";

  // The contact form's optional inquiry-type <select> (see
  // sections/contact-form.liquid + assets/section-contact-form.js). Each
  // <option> carries a stable data-tag (e.g. "inquiry:business") that mirrors
  // Shopify's native contact[tags] mechanism — read that instead of the
  // merchant-editable label text so the event param stays a fixed enum.
  const getInquiryType = (form) => {
    const select = form.querySelector("[data-inquiry-type-select]");
    if (!select) return null;
    const option = select.options[select.selectedIndex];
    // sections/contact-form.liquid always sets data-tag on every option; no
    // select.value fallback here on purpose — that value is the merchant-
    // editable label text, not the fixed enum this event param should carry.
    return (option && option.getAttribute("data-tag")) || null;
  };

  // Newsletter signup forms are `{% form 'customer' %}` like every other
  // customer form (login, register, recover...), so the form_type hidden
  // input alone can't tell them apart. They're marked with a
  // contact[tags]=newsletter hidden input (see sections/newsletter.liquid,
  // sections/newsletter-with-image.liquid, blocks/newsletter.liquid) — use
  // that as the discriminator so we don't fire form_submitted for account forms.
  const isNewsletterForm = (form) =>
    Array.from(form.querySelectorAll('input[name="contact[tags]"]')).some(
      (input) => input.value === "newsletter",
    );

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const formTypeInput = form.querySelector('input[name="form_type"]');
    const formType = formTypeInput ? formTypeInput.value : null;

    if (formType === "contact") {
      const params = { form_type: "contact" };
      const inquiryType = getInquiryType(form);
      if (inquiryType) params.inquiry_type = inquiryType;
      window.gtag("event", "form_submitted", params);
    } else if (formType === "customer" && isNewsletterForm(form)) {
      window.gtag("event", "form_submitted", { form_type: "newsletter" });
    }
  });

  // Contact page embeds Calendly via a custom-liquid block (see
  // templates/page.contact.json). Calendly posts a window message when a
  // visitor completes booking; listen for it rather than the form submit,
  // since the widget is a cross-origin iframe.
  window.addEventListener("message", (event) => {
    if (event.origin !== CALENDLY_ORIGIN) return;

    const data = event.data;
    if (data && data.event === "calendly.event_scheduled") {
      window.gtag("event", "demo_booked");
    }
  });
})();
